import "../assets/css/benefits.css";
import { useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { setTermsAndConditions } from '../redux/data/dataSlice';

function TermsAndConditions(props) {
    const dispatch = useDispatch();
    const termsErrorRef = useRef();
    const termsAndConditions = useSelector(state => state.data.termsAndConditions);
    const handleLinkClick = () => {
        window.open(props.reward.reward_terms + "?ds_save=0", "_blank")
    }

    const handleClick = () => {
        if (!termsAndConditions) {
            termsErrorRef.current.innerHTML = "";
        }
        dispatch(setTermsAndConditions(!termsAndConditions))
    }

    return (
        <div className="modal-terms-div">
            <input type="checkbox" id="modal-terms-checkbox" className="modal-terms-checkbox" onClick={e => handleClick()} />
            <div className="modal-terms">
                <label htmlFor="modal-terms-checkbox">I accept the </label><u className="modal-terms-link" onClick={e => handleLinkClick()}>Terms and conditions</u>
            </div>
            <p id="termsError" className="modal-terms-error" ref={termsErrorRef}></p>
        </div>
    )
}

export default TermsAndConditions;
